import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { GuidItemModel } from "../models/shared/guidItem";
import { IEntryReportDTO } from "../models/entry/entryExportDTO";
let ReportModule = /** @class */ (() => {
    var _a, _b, _c;
    let ReportModule = class ReportModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "Report";
            this.hightLights = [];
            this.reportsTemplate = [];
        }
        SetHightLights(hightLights) {
            this.hightLights = hightLights;
        }
        SetReports(reportsTemplate) {
            this.reportsTemplate = reportsTemplate;
        }
        async GetReportTemplateAndHighlightListForReports() {
            var url = `${getTenantId()}/${this.apiNode}/`;
            let { data } = await service.get(url);
            if (data) {
                this.SetHightLights(plainToClass(GuidItemModel, data.highLights));
                this.SetReports(plainToClass(GuidItemModel, data.reportsTemplate));
                return data;
            }
        }
        async ExportReport(report) {
            var url = `${getTenantId()}/${this.apiNode}/exportEntries`;
            let { data } = await service.post(url, report, { responseType: "blob" });
            if (data) {
                console.log(data);
                return data;
            }
        }
    };
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ReportModule.prototype, "SetHightLights", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ReportModule.prototype, "SetReports", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], ReportModule.prototype, "GetReportTemplateAndHighlightListForReports", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof IEntryReportDTO !== "undefined" && IEntryReportDTO) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], ReportModule.prototype, "ExportReport", null);
    ReportModule = __decorate([
        Module({ dynamic: true, store: store, name: "reports", namespaced: true })
    ], ReportModule);
    return ReportModule;
})();
export const ReportsModule = getModule(ReportModule);
